import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import SocialProofBanner from "@/components/site/SocialProofBanner";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Gallery from "@/components/site/Gallery";
import FacebookFeed from "@/components/site/FacebookFeed";
import Testimonials from "@/components/site/Testimonials";
import ContactForm from "@/components/site/ContactForm";
import Footer from "@/components/site/Footer";
import HomeSeo from "@/components/site/HomeSeo";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#F5F7FA] text-[#0A0E1A] font-sans" data-testid="landing-page">
      <HomeSeo />
      <Header />
      <main>
        <Hero />
        <SocialProofBanner />
        <Services />
        <About />
        <Gallery />
        <FacebookFeed />
        <Testimonials />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
